<template>
  <div id="app">
    <div id="club-edit">
      <Header
        @update="update()"
        :page="'club_edit'"
        :title_one="'club_edit'"
        :title_two="'edit'"
        :action_one="'save'"
        :action_two="'cancel'"
      ></Header>
      <!-- <h2 class="title">{{$t('titles.club_edit')}}</h2> -->
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <div class="box">
            <!-- NAME -->
            <!-- <div class="item">
                  <label>{{$t('params.club_name')}}</label>
                  <input type="text" disabled v-model="club.name" >
                </div> -->

            <!-- SHIELD -->
            <div class="item">
              <div class="image">
                <ClipperImage
                  v-if="clipper"
                  :image="clipper"
                  :ratio="3 / 3"
                  :area="50"
                  @getImage="showThumb"
                ></ClipperImage>
                <label
                  >{{ $t("params.shield") }} <span class="obligatory">*</span>
                </label>
                <img
                  @click="addThumbnail()"
                  v-if="shield_preview"
                  :src="shield_preview"
                />
                <div @click="addThumbnail()" v-else class="addThumb">
                  <div class="add" :class="{ error: error.shield }">
                    <v-icon x-large>add</v-icon>
                    <div class="text">
                      {{ $t("add") + " " + $t("params.shield") }}
                    </div>
                  </div>
                </div>
                <input
                  type="file"
                  style="display: none"
                  :ref="'image_input'"
                  accept="image/png, image/jpeg"
                  @change="onThumbnailPicked"
                />
              </div>
              <span :class="{ error: error.shield_size }">{{
                $t("descriptions.file_size", { s: "200KB" })
              }}</span>
            </div>

            <div class="item"></div>

            <!-- PHONE -->
            <div class="item">
              <label
                >{{ $t("params.phone") }} <span class="obligatory">*</span>
                <span v-if="error.invalit_phone" class="obligatory">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <!-- <input v-bind:class="error.phone ? 'error' : ''" type="tel" v-model="input.phone" :placeholder="$t('params.phone')"> -->
              <vue-tel-input
                v-model="input.phone"
                @input="clubPhone"
                autocomplete="nope"
                style="border:none"
                :class="error.phone ? 'error' : ''"
                :placeholder="''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
                name="mic-input"
              ></vue-tel-input>
            </div>

            <!-- PHONE2 -->
            <div class="item">
              <label
                >{{ $t("params.phone2") }} <span class="obligatory">*</span>
                <span v-if="error.invalit_mobile" class="obligatory">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <!-- <input v-bind:class="error.mobile ? 'error' : ''" type="tel" v-model="input.mobile" :placeholder="$t('params.mobile')"> -->
              <vue-tel-input
                v-model="input.mobile"
                @input="clubMobile"
                autocomplete="nope"
                style="border:none"
                :class="error.mobile ? 'error' : ''"
                :placeholder="''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
                name="mic-input"
              ></vue-tel-input>
            </div>

            <!-- EMAIL -->
            <div class="item">
              <label
                >{{ $t("params.email") }} <span class="obligatory">*</span>
                <span v-if="error.invalit_mail" class="obligatory">
                  {{ $t("errors.email") }}</span
                >
              </label>
              <input
                v-bind:class="error.mail ? 'error' : ''"
                type="email"
                v-model="input.mail"
                :placeholder="$t('params.mail')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- WEB -->
            <div class="item">
              <label>{{ $t("params.web") }}</label>
              <input
                type="text"
                v-model="input.web"
                :placeholder="$t('params.web')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- ADDRESS -->
            <div class="item">
              <label>{{ $t("params.address") }}</label>
              <input
                type="text"
                v-model="input.address"
                :placeholder="$t('params.address')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- CITY -->
            <div class="item">
              <label>{{ $t("params.city") }}</label>
              <input
                type="text"
                v-model="input.city"
                :placeholder="$t('params.city')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- CP -->
            <div class="item">
              <label>{{ $t("params.cp") }}</label>
              <input
                type="text"
                v-model="input.cp"
                :placeholder="$t('params.cp')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- STATE -->
            <div class="item">
              <label>{{ $t("params.state") }}</label>
              <input
                type="text"
                v-model="input.state"
                :placeholder="$t('params.state')"
                name="mic-input"
                autocomplete="nope"
              />
            </div>

            <!-- COUNTRY -->
            <div class="item">
              <label
                >{{ $t("params.country") }} <span class="obligatory">*</span>
              </label>
              <v-autocomplete
                :class="error.country ? 'error' : ''"
                v-model="input.country_id"
                :items="Object.values(countries)"
                item-text="name"
                item-value="id"
                no-data
                hide-no-data
                name="mic-input"
                autocomplete="nope"
              >
              </v-autocomplete>
            </div>
            <div class="item"></div>
          </div>

          <div class="box">
            <template v-if="current_event_type_id == '15'">
              <h3>{{ $t("titles.tax_info") }}</h3>
              <div class="item">
                <label>{{ $t("params.tax_id") }}</label>
                <input
                  type="text"
                  v-model="input.tax_id"
                  :placeholder="$t('params.tax_id')"
                  name="mic-input"
                  autocomplete="nope"
                />
              </div>

              <div class="item">
                <label>{{ $t("params.tax_name") }}</label>
                <input
                  type="text"
                  v-model="input.tax_name"
                  :placeholder="$t('params.tax_name')"
                  name="mic-input"
                  autocomplete="nope"
                />
              </div>

              <div class="item">
                <label>{{ $t("params.tax_address") }}</label>
                <input
                  type="text"
                  v-model="input.tax_address"
                  :placeholder="$t('params.tax_address')"
                  name="mic-input"
                  autocomplete="nope"
                />
              </div>
              <div class="item"></div>
            </template>

          </div>
          <ErrorPopup
            @close="closePopup()"
            @input="closePopup()"
            :dialog="dialog"
          ></ErrorPopup>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ClipperImage from "@/components/ui/ClipperImage.vue";
import Header from "@/components/layout/Header";
import ErrorPopup from "@/components/ui/ErrorPopup.vue";

export default {
  name: "ClubEdit",
  components: {
    ClipperImage,
    Header,
    ErrorPopup
  },
  data() {
    return {
      user: {},
      club: {},
      countries: {},
      shield_preview: "",
      clipper: false,
      dialog: false,
      input: {
        name: "",
        abbreviation: "",
        phone: "",
        mobile: "",
        mail: "",
        web: "",
        address: "",
        city: "",
        cp: "",
        state: "",
        shield: {},
        country_id: "",
        phone_aux: "",
        mobile_aux: "",
        tax_id: "",
        tax_name: "",
        tax_address: ""
      },
      error: {
        phone: false,
        mobile: false,
        mail: false,
        shield: false,
        country: false,
        invalit_phone: false,
        invalit_mobile: false,
        invalit_mail: false,
        shield_size: false
      },
      current_event_type_id: null
    };
  },
  created() {
    this.load()
  },

  computed: {
    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  created () {
    this.load()
  },
  methods: {
    load() {
        this.current_event_type_id = this.$store.getters["getCurrentEvent"]().type_id;

        // get user information from store
        this.user = this.$store.getters["user/getUser"];
        // check if user isn't admin
        if (!this.user.admin) {
        this.$router.push({ name: "home" });
        }
        var self = this;
        // get countries
        console.log("LOAD TABLES RELATIONSHIP");
        this.$store.dispatch("loadTablesRelationship").then(function() {
        self.countries = self.$store.getters["getCountries"];
        // get other information
        console.log("GET CLUB INFORMATION: ", self.user.club_id, self.user.event_id);

        self.$store
            .dispatch("club/loadClubEvent", {
            club_id: self.user.club_id,
            event_id: self.user.event_id
            })
            .then(function() {
            self.club = self.$store.getters["club/getClub"];
            console.log(self.club);
            self.input.name = self.club.name;
            self.input.abbreviation = self.club.abbreviation;
            self.input.phone = '+' + self.club.phone;
            self.input.mobile = '+' + self.club.mobile;
            self.input.mail = self.club.mail;
            self.input.web = self.club.web;
            self.input.address = self.club.address;
            self.input.city = self.club.city;
            self.input.cp = self.club.cp;
            self.input.state = self.club.state;
            self.input.shield = self.club.shield;
            self.input.country_id = self.club.country_id;
            self.shield_preview = self.input.shield;
            self.input.tax_id = self.club.tax_id;
            self.input.tax_name = self.club.tax_name;
            self.input.tax_address = self.club.tax_address;
            // save originals
            self.original_phone = '+' + self.club.phone;
            self.original_mobile = '+' + self.club.mobile;
            });
        });
    },
    validate() {
      var validate = true;

      // validate phone
      if (
        isEmpty(this.original_phone) ||
        isEmpty(this.input.phone) ||
        this.original_phone != this.input.phone
      ) {
        if (Object.keys(this.input.phone_aux).length > 0) {
          // validate if club phone is valid
          if (this.input.phone_aux.isValid) {
            // ok save phone
            this.input.phone = this.input.phone_aux.number.e164;
            // remove errors
            this.error.phone = false;
            this.error.invalit_phone = false;
            // invalit phone number
          } else {
            this.error.phone = true;
            this.error.invalit_phone = true;
            validate = false;
          }
        } else {
          this.error.phone = true;
          validate = false;
        }
      }

      // validate mobile
      if (
        isEmpty(this.original_mobile) ||
        isEmpty(this.input.mobile) ||
        this.original_mobile != this.input.mobile
      ) {
        if (Object.keys(this.input.mobile_aux).length > 0) {
          // validate if club phone is valid
          if (this.input.mobile_aux.isValid) {
            // ok save phone
            this.input.mobile = this.input.mobile_aux.number.e164;
            // remove errors
            this.error.mobile = false;
            this.error.invalit_mobile = false;
            // invalit phone number
          } else {
            this.error.mobile = true;
            this.error.invalit_mobile = true;
            validate = false;
          }
        } else {
          this.error.mobile = true;
          validate = false;
        }
      }

      // validate email

      if (isEmpty(this.input.mail)) {
        this.error.mail = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.input.mail)) {
          this.error.mail = false;
          this.error.invalit_mail = false;
          // invalit email
        } else {
          validate = false;
          this.error.mail = true;
          this.error.invalit_mail = true;
        }
      }

      // validate shield if is empty
      if (!this.shield_preview) {
        this.error.shield = true;
        validate = false;
      } else {
        this.error.shield = false;
      }

      // validate for new shield
      if (typeof this.input.shield == "object") {
        // validate size (200KB max)
        console.log(this.input.shield);
        console.log(this.input.shield.size / 1024);
        console.log(this.input.shield.size / 1024 > 200);
        if (this.input.shield.size / 1024 > 200) {
          validate = false;
          this.error.shield = true;
          this.error.shield_size = true;
        } else {
          this.error.shield = false;
          this.error.shield_size = false;
        }
      }

      // validate country
      if (isEmpty(this.input.country_id)) {
        this.error.country = true;
        validate = false;
      } else {
        this.error.country = false;
      }

      return validate;
    },

    update() {
      if (this.validate()) {
        var self = this;
        // check if is not required to upload
        if (this.input.shield == this.shield_preview) {
          this.$store
            .dispatch("club/updateClub", {
              club_id: self.club.id,
              input: self.input
            })
            .then(function() {
              self.$router.push({ name: "club" });
            });
        } else {
          this.$store
            .dispatch("club/upload", {
              club_id: self.club.id,
              input: self.input
            })
            .then(function() {
              self.$router.push({ name: "club" });
            });
        }
      } else {
        this.dialog = true;
      }
    },

    addThumbnail() {
      //UNBLOCKED BY MIC
      this.$refs["image_input"].click();
    },

    onThumbnailPicked(e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (this.clipper) URL.revokeObjectURL(this.clipper);
        this.clipper = window.URL.createObjectURL(e.target.files[0]);
      }
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    resizeToWebP(dataURL, maxW = 1024, maxH = 1024, quality = 0.8) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          let w = img.width, h = img.height;
          if (w > maxW) { h = h * (maxW / w); w = maxW; }
          if (h > maxH) { w = w * (maxH / h); h = maxH; }
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/webp', quality));
        };
        img.src = dataURL;
      });
    },

    async showThumb(image) {
      this.clipper = false;

      const webpDataURL = await this.resizeToWebP(image, 250, 250, 0.8);

      this.shield_preview = webpDataURL;

      const idx = moment().valueOf();
      const fileName = `shield_${idx}.webp`;
      this.input.shield = this.dataURLtoFile(webpDataURL, fileName);
    },

    closePopup() {
      this.dialog = false;
    },

    clubPhone(input, oResult) {
      this.input.phone_aux = oResult;
    },

    clubMobile(input, oResult) {
      this.input.mobile_aux = oResult;
    }
  }
};
</script>
<style lang="scss">
#app {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;
}

#club-edit {
  .box {
    width: 100%;
    margin: 0 auto;
    width: 80%;
    height: 80%;
    overflow: auto;
    text-align: center;

    .message.error {
      color: $warning-color;
    }

    .item {
      width: calc(50% - 20px);
      margin: 10px 10px;
      display: inline-block;
      vertical-align: top;

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 16px;
      }

      .error {
        border-color: red !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 1;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
        .vti__input {
          border-color: red !important;
        }
        color: red;
        font-weight: bold;
      }

      label {
        font-size: 14px;
        padding: 0;
        margin-bottom: 5px;
        display: block;
      }

      input,
      select,
      .v-autocomplete .v-input__slot {
        width: 100%;
        padding: 15px;
        margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }

      .v-autocomplete {
        margin-top: 0;
        padding-top: 0;

        .v-input__control {
          .v-input__slot {
            margin: 0;
            padding: 8px;

            &:after,
            &:before {
              content: "";
              border: none !important;
            }
          }
          .v-select__slot {
            border: none;

            input {
              border: none;
              margin: 0;
            }
          }
        }

        .obligatory {
          color: $alert-color;
          font-weight: bold;
        }

        .error {
          border-color: $alert-color !important;
          &::placeholder {
            color: $alert-color !important;
            opacity: 0.5;
          }
          .v-input__slot {
            border-color: $alert-color;
          }
        }
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    .form-subtitle {
      margin-top: 36px;

      &:first-of-type {
        margin-top: 12px;
      }
    }

    button {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #222;
      color: $secondary-color;

      &:hover {
        background: $main-color;
      }
    }

    .image {
      width: 150px;
      height: 150px;
      padding: 0 40px 0 0px;
      overflow: hidden;

      img,
      .addthumb {
        width: auto;
        border: 1px solid #ccc;
        // height: 100px;
        position: relative;
        cursor: pointer;
      }
      .addthumb div {
        width: 100%;
        display: block;
        top: 35%;
        position: absolute;
        text-align: center;
      }
      .addthumb .text {
        top: 60%;
      }
    }

    .add {
      border: 2px dashed #eee;
      text-align: center;
      min-height: 100px;
      padding-top: 15px;

      .text {
        text-align: center;
      }
    }
  }
}

@include media("<=desktop") {
  #club-edit {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;
      .item {
        width: 100%;
        display: block;
        margin: 10px 0;
      }

      .image {
        display: block;
        float: none;
        text-align: center;
        margin: 0 auto;
      }
    }
  }
}
</style>
